export const APP_NAME = "Consultoría Global";
export const APP_VERSION = "1.0.0";

export const CONTACT_INFO = {
  EMAIL: "contact@consultoriaglobal.com",
  PHONE: "+54-XXX-XXX-XXXX",
} as const;


export const INTRANET_URL = "http://200.32.52.77:8080/cgintranet/#signInPage";